import { Form, Input, Select } from "antd";
import { useMemo } from "react";
import countryList from "react-select-country-list";

import FormModal from "../../../common/modal/FormModal";

import { MyFormItem } from "../../MyFormItem";

interface CompanyCreateModalProps {
  open: boolean;
  onCancel: () => void;
  onCreate: (data: {
    companyName: string;
    corporateName?: string;
    country?: string;
  }) => void;
  loading?: boolean;
  createError?: string | null;
}

export default function CompanyCreateModal({
  open,
  onCancel,
  onCreate,
  loading = false,
  createError,
}: CompanyCreateModalProps) {
  const [form] = Form.useForm();

  const countryOptions = useMemo(
    () =>
      countryList()
        .getData()
        .map((c: { label: string }) => ({
          label: c.label,
          value: c.label,
        })),
    [],
  );

  const handleSubmit = (values: any) => {
    const cleanedValues = {
      ...values,
      corporateName: values.corporateName || null,
      country: values.country || null,
    };

    onCreate(cleanedValues);
  };

  return (
    <FormModal
      title="Create New Company"
      open={open}
      onCancel={onCancel}
      form={form}
      formId="createCompanyForm"
      onFinish={handleSubmit}
      isSubmitting={loading}
      submitLabel="Create Company"
      error={createError}
      afterClose={() => form.resetFields()}
    >
      {/* Company Name */}
      <MyFormItem
        label="Company Name"
        name="companyName"
        rules={[{ required: true, message: "Company name is required" }]}
      >
        <Input placeholder="Bitmaker" />
      </MyFormItem>

      {/* Corporate / Legal Name */}
      <MyFormItem
        label="Corporate / Legal Name (optional)"
        name="corporateName"
      >
        <Input placeholder="Bitmaker E.I.R.L." />
      </MyFormItem>

      {/* Country */}
      <MyFormItem label="Country (optional)" name="country">
        <Select
          placeholder="Select country"
          options={countryOptions}
          showSearch
          filterOption={(input, option) =>
            (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
          }
        />
      </MyFormItem>
    </FormModal>
  );
}
